// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func } from 'prop-types'
import { useModalContext } from 'components'
import useCallsignCascade from './hooks/useCallsignCascade'
import Form from './Form'

const idRoot = 'callsign-cascade-modal'

const CallsignCascade = ({ callsignCascadeData, handleSuccessfulSubmitCallback }) => {
  const { closeContextModal } = useModalContext()

  const handleSubmit = useCallsignCascade(handleSuccessfulSubmitCallback)

  return (
    <div>
      <h3 className={'display-flex justify-content-between bg-blue-dark padding-half'}>
        <span id={`${idRoot}-heading`}>{'Call Sign Cascade'}</span>
        <i
          className={'fa fa-times'}
          id={`${idRoot}-close`}
          onClick={closeContextModal} />
      </h3>
      <Form
        callsignCascadeData={callsignCascadeData}
        closeModal={closeContextModal}
        onSubmit={handleSubmit} />
    </div>
  )
}

CallsignCascade.propTypes = {
  callsignCascadeData: array.isRequired,
  handleSuccessfulSubmitCallback: func.isRequired,
}

export default CallsignCascade

export const modalConfig = {
  onRequestClose: null, // prevents close when clicking the modal overlay
  styles: {
    content: {
      maxWidth: 900,
      width: 'auto',
    },
  },
}
